module.exports = __webpack_public_path__ + "static/media/paw.a67c80c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/MemberProfile/paw.svg
// module id = 365
// module chunks = 0